<template>
  <p class="currency-disclaimer small">
    <span v-if="onlyUsd">
      {{ $t('allPurchases') }}
    </span>

    <span v-else-if="chargeableCurrency">
      {{ $t('currencyDisclaimerCharge') }}
    </span>

    <span v-else-if="currency != 'USD'">
      {{ $t('currencyDisclaimer') }}
    </span>
  </p>
</template>

<script>
import CurrencyApi from './currency-api'

export default {

  props: ['currency', 'chargeablecurrencies'],
  data() {
    return {
      allCurrencies: null
    }
  },

  computed: {
    onlyUsd() {
      if (this.allCurrencies) {
        return this.allCurrencies.length <= 1
      } else if (this.chargeablecurrencies) {
        return this.chargeablecurrencies.length <= 1
      } else {
        return true
      }
    },

    chargeableCurrency() {
      if (this.chargeablecurrencies) {
        return this.chargeablecurrencies.includes(this.currency)
      } else {
        return false
      }
    }
  },

  watch: {
    chargeablecurrencies() {
      this.$emit('only-usd-emit', this.onlyUsd)
    }
  },

  mounted() {
    CurrencyApi.availableCurrencies().then(currencies => {
      if (currencies.currencies) {
        this.allCurrencies = currencies.currencies
      }

      this.$emit('only-usd-emit', this.onlyUsd)
    })
  }
}
</script>
